import { first, map, omitBy, isEmpty, isNil } from 'lodash';
import moment from 'moment';
import normalizer from '..';

const response = (data: any) => {
    let purchaseType = "VOUCHER";
    let allowVoucherCancellation = false;
    const itemList = map(data.items, itemObj => {
      itemObj.product = normalizer.response.inventoryTranslation(itemObj.product);
      let productType = itemObj.product.product.type;
      if(productType){
        purchaseType = productType // NORMAL | VOUCHER | NO_SHIPPING
      }
      if(itemObj.vouchers){
        allowVoucherCancellation = itemObj.vouchers[0]?.cancellationExpiryDate ? moment() <= moment(itemObj.vouchers[0]?.cancellationExpiryDate) : false
      }
      return {
        ...itemObj,
        productName: itemObj.product.product.name,
        productCode: itemObj.product.product.code,
        productType: productType,
        productStockInfo: itemObj.product.product,
      }
    })
    if (!isEmpty(data.itemsData)) {
      data.itemsData = data.itemsData.map(m => normalizer.response.inventoryTranslation(m))
    }


    return omitBy({
      ...data,
      receiverData: data.receiver,
      purchaseType: purchaseType,
      allowVoucherCancellation : allowVoucherCancellation,
      supplierData: data.supplier,
      items: itemList
    }, isNil)
}

export default response;
